import { Modal } from '@mui/material';
import { ReactElement } from 'react';

export default function CustomModal({
  children,
  handleClose,
  open,
}: {
  children: ReactElement;
  handleClose: () => any;
  open: boolean;
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      {children}
    </Modal>
  );
}
